import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_EncounterSimulation, DBDef_EncounterSimulation, } from '@app/ehr-emulator-shared';
export const dispatch_onEncounterSimulationChanged = new ThunderDispatcherV3('__onEncounterSimulationUpdated');
export class ModuleFE_EncounterSimulation_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EncounterSimulation, dispatch_onEncounterSimulationChanged);
        this._v1 = {
            createEncounterSimulation: apiWithBody(ApiDef_EncounterSimulation._v1.createEncounterSimulation),
            getSimulationLaunchJwt: apiWithBody(ApiDef_EncounterSimulation._v1.getSimulationLaunchJwt),
            clearOldSimulations: apiWithBody(ApiDef_EncounterSimulation._v1.clearOldSimulations),
        };
    }
}
export const ModuleFE_EncounterSimulation = new ModuleFE_EncounterSimulation_Class();
//# sourceMappingURL=ModuleFE_EncounterSimulation.js.map